type CallbackType = (callback) => void;
// h5与app端交互hooks
import { utilIsAndroid, utilIsIos, utilIsFlutter } from "@/utils";
const setupWebViewJavascriptBridge = (callback: CallbackType) => {
  //Flutter使用
  if (utilIsFlutter()) {
    if ((window as any).flutter_inappwebview) {
      callback((window as any).flutter_inappwebview);
    } else {
      document.addEventListener(
        "flutterInAppWebViewPlatformReady",
        () => {
          callback((window as any).flutter_inappwebview);
        },
        false
      );
    }
  }

  //Android使用
  if (utilIsAndroid()) {
    if ((window as any).WebViewJavascriptBridge) {
      callback((window as any).WebViewJavascriptBridge);
    } else {
      document.addEventListener(
        "WebViewJavascriptBridgeReady",
        () => {
          callback((window as any).WebViewJavascriptBridge);
        },
        false
      );
    }
  }

  //iOS使用
  if (utilIsIos()) {
    if ((window as any).WebViewJavascriptBridge) {
      return callback((window as any).WebViewJavascriptBridge);
    }
    if ((window as any).WVJBCallbacks) {
      return (window as any).WVJBCallbacks.push(callback);
    }
    (window as any).WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement("iframe");
    WVJBIframe.style.display = "none";
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(() => {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
};

// js调APP方法 （参数分别为:app提供的方法名  传给app的数据  回调）
const useCallAppHandle = (
  name: string = "",
  data: any = null,
  callback = (_res: string | object) => {}
) => {
  setupWebViewJavascriptBridge((bridge) => {
    let filterData;
    if (typeof data == "string") {
      filterData = data;
    } else if (typeof data == "object") {
      filterData = JSON.stringify(data);
    }

    if (!bridge?.callHandler) {
      setTimeout(() => {
        useCallAppHandle(name, data, callback);
      }, 1000);
      return;
    }

    if (utilIsFlutter()) {
      bridge.callHandler(name, filterData, callback).then((res: any) => callback(res));
    } else {
      bridge.callHandler(name, filterData, callback);
    }

    console.log("【Bridge Info】", { name, filterData });
  });
};

// APP调js方法 （参数分别为:js提供的方法名  回调）
const useRegisterHandler = (name, callback) => {
  setupWebViewJavascriptBridge((bridge) => {
    bridge.registerHandler(name, (data, responseCallback) => {
      callback(data, responseCallback);
    });
  });
};

/**
 * useFormatAppData
 * @param value 接受到app方法返回的值，如果返回是对象格式，安卓端需要特殊处理下，反之，正常返回'1'或'0'这种情况，就无需用此方法
 * @returns object
 */
const useFormatAppData: (value: string | object) => object = (
  value: string | object
) => {
  if (utilIsAndroid() || utilIsFlutter()) {
    try {
      return JSON.parse(value as string);
    } catch (error) {
      return {};
    }
  } else if (utilIsIos()) {
    return value;
  }
};
export { useCallAppHandle, useRegisterHandler, useFormatAppData };
